import { ConfigurationService } from "src/app/services/configuration.service";
import {environment} from "../../../environments/environment";

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nous-contacter',
  templateUrl: './nous-contacter.component.html',
  styleUrls: ['./nous-contacter.component.scss']
})
export class NousContacterComponent implements OnInit {
  configuration = this.configurationService.get();
  MAX_FILE_SELECT=this.configurationService.get().nous_contacter.FileLimit;
  MAX_FILE_SIZE= this.configurationService.get().nous_contacter.FileSize;
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);

  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
